import { h, Component } from 'preact';
import style from './style.less';
import SimpleVerticalCard from '../../cards/simple-vertical-card';
import SpotlightBottomCard from '../../cards/spotlight-bottom-card';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';

import { TrackingProvider, DIMENSION } from '@cube/track';

/**
 * The spotlight cluster used for P23 home page
 * Layout:
 * - one full width simple vertical
 * - fixed width image (72px) horizontal cards
 * @param {Object} assets contents for the cards
*/
export default class SpotlightCluster extends Component {

	state = {
		assets: []
	};

	getAssets = (props) => {
		fetchArticleList({
			count: props.horizontalCardCount + 1,
			imageSizes: 'w=300,h=169|w=72,h=72',
			...props }
		)
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					this.setState({ assets: res.articles });
				}
			});
	};

	static defaultProps = {
		horizontalCardCount: 3
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render(
		{ theme, title, link, qeId, horizontalCardCount, ...props },
		{ assets }
	) {
		if (!assets || assets.length === 0) return null;

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: (title ? title.replace(/\s/g, '') + 'Cluster' : 'SpotlightCluster'), [DIMENSION.title]: title }}>
				<div class={style.categoryCluster} qid={qeId}>
					<CardHeader title={title} link={link} qeId={qeId} theme={theme} />
					<div class={style.cards}>
						<TrackingProvider {...{ [DIMENSION.componentpath]: 'Top', [DIMENSION.clickindex]: 1 }}>
							<SimpleVerticalCard
								theme={theme}
								asset={assets[0]}
								imageRole="w=300,h=169"
								cardClass={style.svCard}
								qeId={qeId + '-top-0'}
								titleLines={2}
								{...props}
							/>
						</TrackingProvider>
						{ assets.length > 1 && assets.slice(1, horizontalCardCount + 1).map((asset, i) => (
							<TrackingProvider {...{ [DIMENSION.componentpath]: 'Bottom', [DIMENSION.clickindex]: i+1 }}>
								<SpotlightBottomCard
									theme={theme}
									asset={asset}
									imageRole="w=72,h=72"
									imageProportion="quarter"
									cardClass={style.sbCard}
									qeId={qeId + '-bottom-' + i}
									{...props}
								/>
							</TrackingProvider>
						)) }
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
